export default __webpack_public_path__ + "static/media/ArialUnicodeMS.28afc366.ttf";